module.exports = __webpack_public_path__ + "static/media/delete.1f50fe83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete.svg
// module id = 391
// module chunks = 33